import React, { useEffect, useState } from "react";

import MainLayout from "../../layouts/MainLayout";

import DeleteModal from "../../modals/DeleteModal";
import useGetCriteriaGroup from "../../../hooks/criteria-group/useGetCriteriaGroup";
import { ICriteriaGroup } from "../../../types/criteriaGroup";
import SideBar from "../../subcomponents/criteria-groups/Sidebar";
import CriteriaGroup from "../../subcomponents/criteria-groups/CriteriaGroup";
import Criteria from "../../subcomponents/criteria-groups/Criteria";
import CriteriaDetails from "../../subcomponents/criteria-groups/CriteriaDetails";
import useGetQuestionsByQuestionnaire from "../../../hooks/question/useGetQuestionByQuestionnaire";
import { useParams } from "react-router-dom";

const CriteriaGroups = () => {
  const params = useParams();

  const [currOption, setCurrOption] = useState<number[]>([]);
  const [criteriaGroups, setCriteriaGroups] = useState<ICriteriaGroup[]>([]);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    setCurrOption([0]);
  }, []);

  const { data, refetch, isPending, isError } = useGetCriteriaGroup();
  const {
    data: questions,
    refetch: refetchQuestions,
    isPending: isPendingQuestions,
    isError: isErrorQuestions,
  } = useGetQuestionsByQuestionnaire();

  useEffect(() => {
    if (params.questcode) {
      refetch();
      refetchQuestions();
      setCurrOption([0]);
    }
  }, [params.questcode]); // eslint-disable-line

  useEffect(() => {
    if (!isError && !isPending) setCriteriaGroups([...data]);
  }, [data, isPending, isError]);

  if (isPending || isPendingQuestions) return <p>Loading...</p>;
  if (isError || isErrorQuestions || !criteriaGroups) return <p>Error!!</p>;

  return (
    <MainLayout>
      {isOpenDeleteModal && (
        <DeleteModal
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          setIsDelete={setIsDelete}
          title="Are you sure you?"
          subtitle="This is an irrecoverable action. All data will be lost."
        />
      )}
      <div className="imm_quest_admin__main_view">
        <SideBar
          currOption={currOption}
          setCriteriaGroups={setCriteriaGroups}
          setCurrOption={setCurrOption}
          criteriaGroups={criteriaGroups}
          questions={questions}
        />

        <div className="imm_quest_admin__main_content">
          {currOption.length === 1 && (
            <CriteriaGroup
              currOption={currOption}
              setCurrOption={setCurrOption}
              criteriaGroups={criteriaGroups}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
            />
          )}
          {currOption.length === 2 && (
            <Criteria
              currOption={currOption}
              setCurrOption={setCurrOption}
              criteriaGroups={criteriaGroups}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
            />
          )}
          {currOption.length === 3 && (
            <CriteriaDetails
              currOption={currOption}
              setCurrOption={setCurrOption}
              criteriaGroups={criteriaGroups}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
              questions={questions}
            />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default CriteriaGroups;
